import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["upload", "dropzone"];

  declare uploadTarget: HTMLInputElement;
  declare hasUploadTarget: boolean;
  declare dropzoneTarget: HTMLDivElement;

  enterCounter = 0;

  dragEnter() {
    if (!this.hasUploadTarget) return;

    this.enterCounter += 1;

    this.dropzoneTarget.style.display = "block";
  }

  dragLeave() {
    if (!this.hasUploadTarget) return;

    if (this.enterCounter > 0) {
      this.enterCounter -= 1;
    }

    if (this.enterCounter === 0) {
      this.dropzoneTarget.style.display = "none";
    }
  }

  drop(e: DragEvent) {
    if (!this.hasUploadTarget) return;
    if (!e.dataTransfer) return;

    if ([...e.dataTransfer.items].some((item) => item.kind === "file")) {
      e.preventDefault();
    }

    this.dragLeave();

    this.uploadTarget.files = e.dataTransfer.files;
    this.uploadTarget.dispatchEvent(new Event("change"));
  }

  dragOver(e: DragEvent) {
    if (!this.hasUploadTarget) return;
    if (!e.dataTransfer) return;

    const fileItems = [...e.dataTransfer.items].filter(
      (item) => item.kind === "file",
    );

    if (fileItems.length <= 0) {
      return;
    }

    e.preventDefault();
    e.dataTransfer.dropEffect = "copy";
  }
}
